<div class="joint-app" [class]="['--' + mode, '--' + view]" #jointApp>
  <div class="joint-app-header px-3 pt-2">
    <div class="flex-grow-1">
      <ul class="nav nav-tabs" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="reorderTabs($event)">
        @for (tab of canvasTabs; track tab; let index = $index) {
          <li class="nav-item joint-tabs-item" cdkDrag [cdkDragDisabled]="mode !== 'edit'">
            <a class="nav-link" [class.active]="activeTab === index" (click)="setActiveTab(index)">
              <span>{{ tab.tab_name }}</span>
              @if (mode === 'edit') {
                <i class="pi pi-pencil nav-edit" (click)="editTab(tab);"></i>
              }
              @if (mode === 'edit' && canvasTabs.length > 1) {
                <i class="pi pi-trash nav-edit" (click)="confirmTabDelete(tab, index);"></i>
              }
            </a>
          </li>
        }
        @if (mode === 'edit') {
          <li class="nav-item">
            <span class="nav-link nav-link-new" (click)="addNewTab();">
              <i class="pi pi-plus"></i>
            </span>
          </li>
        }
      </ul>
    </div>
    @if (view !== 'presentation') {
      <div class="pb-2">
        @if (mode === 'view') {
          <button class="btn btn-info2 text-light" (click)="setEditMode(); getTabs(); editCanvas();">Edit</button>
        }
        @if (mode === 'edit') {
          <button class="btn btn-info1 text-light mx-2" (click)="loadingService.apiLoader = true; saveCanvas()">Save</button>
        }
        @if (mode === 'edit') {
          <button class="btn btn-info1 text-light mx-2" (click)="loadingService.apiLoader = true; saveCanvas(); setViewMode(); getTabs(); fitCanvas();">Save & Exit</button>
        }
      </div>
    }
    @if (view === 'presentation') {
      <div class="pb-2 d-flex justify-content-between align-items-center">
        @if (isApplicationsExist) {
          <div class="btn-group btn-group-sm">
            @for (key of fataList; track key) {
              <button class="btn btn-fata" [ngClass]="faTaColorKey === key.value ? 'active' : ''" (click)="faTaColor('applications', key.value)">{{ key.label }}</button>
            }
          </div>
        }
        @if (isCustomPropertiesExist) {
          <div class="mx-1">
            <select class="form-select form-select-sm" [(ngModel)]="selectedCustomProperty" (ngModelChange)="filterByCustomProperty($event)" style="width: 200px;">
              <option value="">Identify Opportunities</option>
              @for (prop of customPropertiesList; track prop) {
                <option [value]="prop.value">{{ prop.label }}</option>
              }
            </select>
          </div>
        }
      </div>
    }
  </div>
  <div #toolbarContainer class="toolbar-container"></div>
  <div class="joint-app-body">
    <div #stencilContainer class="stencil-container"></div>
    <div #paperContainer class="paper-container"></div>
    <div #inspectorContainer class="inspector-container hidden">
      <div #inspectorHeader class="inspector-header hidden">
        <button #openGroupsButton class="open-groups-btn"></button>
        <button #closeGroupsButton class="close-groups-btn"></button>
        <span class="inspector-header-text">Properties</span>
      </div>
      <div #inspectorContent class="inspector-content"></div>
    </div>
    <div #navigatorContainer class="navigator-container"></div>
  </div>
</div>
<p-dialog [header]="tabModel._id ? 'Rename Tab' : 'New Tab'" [modal]="true" [(visible)]="tabRenameDialog" [style]="{ width: '25rem' }" (onHide)="onTabDialogHide()">
  <div class="col-12 py-3">
    <input id="name" class="form-control" autocomplete="off" [(ngModel)]="tabModel.tab_name" placeholder="Tab Name" />
  </div>
  <div class="d-flex justify-content-end">
    <button class="btn btn-info2 text-white" (click)="saveTab()">Save</button>
  </div>
</p-dialog>

<p-dialog [header]="'Edit'" [modal]="true" [(visible)]="textEditor.visible" [style]="{ width: '50rem' }" (onHide)="hideEditor()">
  <p-editor [(ngModel)]="textEditor.content" class="joint-text-full-editor" [style]="{ height: '320px' }" [modules]="editorModules">
  </p-editor>
  <div class="d-flex justify-content-end pt-3">
    <button class="btn btn-info2 text-white px-5" (click)="saveEditorContent()">Save</button>
  </div>
</p-dialog>

<!-- editor popup on input page -->
<p-dialog header="Opportunity Description" [modal]="true" [(visible)]="elementOpportunityEditor.visible" styleClass="opportunity-editor-popup" (onHide)="hideOpportunityEditor()">
  <label class="form-label">Opportunity Type:
    <span class="fw-bold mb-0">{{ elementOpportunityEditor.opportunityType }}</span>
  </label>
  <p-editor [(ngModel)]="elementOpportunityEditor.content" class="joint-text-full-editor" [modules]="editorModules"></p-editor>
  <div class="d-flex justify-content-end pt-3">
    <button class="btn btn-info2 text-white px-5" (click)="saveElementOpportunityDescription()">Save</button>
  </div>
</p-dialog>

<!-- description popup on presentation page -->
<p-dialog header="Opportunity Description" [modal]="true" [(visible)]="elementOpportunityDescriptionPopup.visible" styleClass="opportunity-description-popup" (onHide)="hideOpportunityDescriptionPopup()">
  <label class="form-label">Opportunity Type:
    <span class="fw-bold mb-0">{{ elementOpportunityDescriptionPopup.opportunityType }}</span>
  </label>
  <div [innerHTML]="elementOpportunityDescriptionPopup.description" class="border p-3 bg-light opportunity-description-content"></div>
  <div class="d-flex justify-content-end pt-2">
    <button class="btn btn-info2 text-white px-3" (click)="hideOpportunityDescriptionPopup()">Close</button>
  </div>
</p-dialog>
